// TerminalEntry → DOM 行 / Render a single log row.
// phase 行追加 .phase-flash（一次性 900ms 动画）+ [RIPPLE] 这类色片；error/warn 行染色。
// phase rows get a one-shot 900ms flash + [PHASE] tag; errors / warnings get colored.

import type { TerminalEntry } from "@/features/log-terminal/terminal-types";

/**
 * 渲染一条 TerminalEntry 为 <div class="terminal-row"> 元素。
 * Render one entry to a terminal row element.
 */
export function renderEntryRow(entry: TerminalEntry): HTMLElement {
  const row = document.createElement("div");
  row.className = "terminal-row";
  row.title = entry.text;
  if (entry.severity === "phase") row.classList.add("phase-flash", "terminal-row-phase");
  if (entry.severity === "error") row.classList.add("terminal-row-error");
  if (entry.severity === "warn") row.classList.add("terminal-row-warn");
  if (entry.severity === "system") row.classList.add("terminal-row-system");

  const ts = document.createElement("span");
  ts.className = "terminal-row-ts";
  ts.textContent = new Date(entry.timestamp).toLocaleTimeString("en-US", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const body = document.createElement("span");
  body.className = "terminal-row-body";
  if (entry.phase) {
    const tag = document.createElement("span");
    tag.className = "terminal-phase-tag";
    tag.textContent = `[${entry.phase}]`;
    body.append(tag);
  }
  const txt = document.createElement("span");
  txt.className = "terminal-row-text";
  txt.textContent = entry.text;
  body.append(txt);

  row.append(ts, body);
  return row;
}
